import appStore from '../utils/state';
import { addToCart } from '../utils/addToCart';

export default class QuickBuyButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;

  private isOneSizeProduct: boolean = false;
  private variantId: string | null = null;

  private onClickBound = this.onClick.bind(this);

  connectedCallback(): void {
    this.isOneSizeProduct = this.getAttribute('data-one-size-product') === 'true';
    this.variantId = this.getAttribute('data-variant-id');

    this.button = this.querySelector('[data-quick-buy-ref="button"]');
    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  onClick(): void {
    if (this.isOneSizeProduct && this.variantId) {
      addToCart([
        {
          id: this.variantId,
          quantity: 1,
          gift_card: false,
          ...(this.getAttribute('data-offer-free-gift') === 'true'
            ? { properties: { _offer_free_gift: '1' } }
            : {}),
        },
      ]);
      return;
    }

    const template = this.querySelector('[data-quick-buy-ref="template"]') as HTMLTemplateElement | null;

    if (!template) {
      return;
    }

    const content = template.content.cloneNode(true) as DocumentFragment;
    appStore.actions.openQuickBuyModal(content);
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('quick-buy-button', QuickBuyButton);
